import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnsubscribeService implements OnDestroy {
  private unsubscribe$ = new Subject<void>();

  // Expose the observable part of the subject
  get unsubscribe() {
    return this.unsubscribe$.asObservable();
  }

  // Call this method when you want to trigger unsubscription
  unsubscribeAll() {
    this.unsubscribe$.next();
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
